import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SidebarMenuItem } from 'src/app/components/sidebar-layout/sidebar-layout.component';
import { FeatureFlagTypes } from 'src/app/models/featureFlag/featureFlagsTypes.enum';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';

enum ConnectTab {
  Integrations = 'integrations',
  Adapters = 'adapters',
}

@Component({
  selector: 'app-connect',
  templateUrl: './connect.component.html',
  styleUrls: ['./connect.component.scss'],
})
export class ConnectComponent implements OnInit {
  public activeItemId: string = ConnectTab.Integrations;
  public menuItems: SidebarMenuItem[] = [
    {
      id: ConnectTab.Integrations,
      label: 'Integrations',
      icon: 'assets/images/menu-icons/blocks.svg',
      route: '/app/connect/integrations',
    },
    {
      id: ConnectTab.Adapters,
      label: 'Adapters',
      icon: 'assets/images/menu-icons/unplug.svg',
      route: '/app/connect/adapters',
    },
  ];
  public isAdaptersLayoutEnabled: boolean;

  constructor(
    private readonly _router: Router,
    private readonly _featureFlagsService: FeatureFlagsService
  ) {
    this.isAdaptersLayoutEnabled = this._featureFlagsService.isFeatureEnabled(
      FeatureFlagTypes.EnableAdaptersLayout
    );
  }

  ngOnInit(): void {
    // Set active tab based on current route
    this._updateActiveTab();

    // Listen to route changes
    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this._updateActiveTab();
    });
  }

  private _updateActiveTab(): void {
    const url = this._router.url;
    if (url.includes('/connect/adapters')) {
      this.activeItemId = ConnectTab.Adapters;
    } else {
      this.activeItemId = ConnectTab.Integrations;
    }
  }

  public onItemSelected(item: SidebarMenuItem): void {
    this.activeItemId = item.id;
    this._router.navigate([item.route]);
  }
}
